export default __webpack_public_path__ + "static/media/JOOZY_BOY.349d582f.svg";